// extracted by mini-css-extract-plugin
module.exports = {"cart-popup-info-icon":"cart-popup-info-icon_3NCjZ","removePropertyListItem":"removePropertyListItem_Upr3F","proceed-msg":"proceed-msg_vr8eb"};